import ClientLogo from "@/components/common/ClientLogo";
import Layout from "@/components/layout/Layout";
import Benefits from "@/components/services/common/Benefits";
import BigImageSection from "@/components/services/common/BigImageSection";
import ServicesHeader from "@/components/services/common/ServicesHeader";
import ITConsultation from "@/components/services/it-consulting/ITConsultation";
import Process from "@/components/services/it-consulting/Process";
import ProjectMaintenance from "@/components/services/it-consulting/ProjectMaintenance";
import { LINK_OF_ALL_PAGES } from "const/common";
import {
  IT_CONSULTATION_DESCRIPTION,
  IT_CONSULTATION_SCHEMA,
  IT_CONSULTATION_TITLE,
  IT_CONSULTATION_URL,
  WHAT_EXPECT_IT_CONSULTING_DATA,
} from "const/services/it-consulting-services";

const ITConsultationAssistance = () => {
  return (
    <Layout
      canonicalLink={IT_CONSULTATION_URL}
      description={IT_CONSULTATION_DESCRIPTION}
      keywords={
        "IT consulting services IT consultant services IT consulting company "
      }
      ogDescription={IT_CONSULTATION_DESCRIPTION}
      ogImage={
        "https://ultroneous.com/assets/services/it-consulting/it-consulting-og.webp"
      }
      ogTitle={IT_CONSULTATION_TITLE}
      ogType={"IT consulting services"}
      ogUrl={IT_CONSULTATION_URL}
      schema={{ ...IT_CONSULTATION_SCHEMA }}
      title={IT_CONSULTATION_TITLE}
      twitterDescription={IT_CONSULTATION_DESCRIPTION}
      twitterImage={
        "https://ultroneous.com/assets/services/it-consulting/it-consulting-og.webp"
      }
      twitterTitle={IT_CONSULTATION_TITLE}
    >
      <ServicesHeader
        details="Be it a project architecture consultation or an ongoing project assistance; let us take care of it for you. When it comes to IT project consultation or assistance for the ongoing live product, ultroNeous is here to take care of it."
        heading="IT Consulting Services"
        pageName="IT Consultation & Assistance"
      />
      <BigImageSection
        alt="IT consulting services "
        details="When it comes to giving IT consultation services for the product architecture, project development strategy or giving a solution design; team ultroNeous dives deep to validate the process. Our IT consultation includes architecture assessment & review, code review, development process audit, process optimization and more. We can take care of the project development process as well as connect with the third party team members if needed to streamline the work. Along with that, we can also take care of your ongoing project and assist you with the additional module development or maintain your web app front end, database as well as mobile application on the monthly contract basis."
        link={LINK_OF_ALL_PAGES.mainPages.contactUs}
        src="/assets/services/it-consulting/consulting.webp"
        title="IT consulting services "
        val="Talk to an expert"
      />
      <div className="py-8 md:py-16 md:px-0 lg:px-10 bg-primary-black">
        <ClientLogo />
      </div>
      <ITConsultation />
      <Process />
      <ProjectMaintenance />
      <div className="py-16 md:px-8 xl:px-10 xl:my-8">
        <Benefits
          data={WHAT_EXPECT_IT_CONSULTING_DATA}
          title="What you can expect?"
        />
      </div>
    </Layout>
  );
};

export default ITConsultationAssistance;
